import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import useContext from '@/composables/useContext';
import BubbleButtonComponent from '@/components/BubbleButtonComponent.vue';


import { defineComponent } from 'vue';

const __default__ = defineComponent({
  name: 'BubbleButton'
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  block: {
    type: Object,
    required: true
  }
},
  setup(__props) {

const props = __props



const { resolveLink } = useContext();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BubbleButtonComponent, {
    to: _unref(resolveLink)(() => __props.block.link)?.url,
    style: _normalizeStyle(__props.block.style),
    label: __props.block.label
  }, null, 8, ["to", "style", "label"]))
}
}

})